import AppLayout from '@/layout/AppLayout.vue';
import { AuthService } from '@/service/AuthService';
import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            component: AppLayout,
            children: [
                {
                    path: '/',
                    name: 'Dashboard',
                    component: () => import('@/views/Dashboard.vue'),
                    meta: { title: 'Dashboard - Solution Experts' }
                },
                {
                    path: '/definition/user',
                    name: 'User',
                    component: () => import('@/views/definition/User.vue'),
                    meta: { title: 'User - Solution Experts' }
                },
                {
                    path: '/definition/accounting-period',
                    name: 'Accounting Period',
                    component: () => import('@/views/definition/AccountingPeriod.vue'),
                    meta: { title: 'Accounting Period - Solution Experts' }
                },
                {
                    path: '/definition/branch',
                    name: 'Branch',
                    component: () => import('@/views/definition/Branch.vue'),
                    meta: { title: 'Branch - Solution Experts' }
                },
                {
                    path: '/definition/warehouse',
                    name: 'Warehouse',
                    component: () => import('@/views/definition/Warehouse.vue'),
                    meta: { title: 'Warehouse - Solution Experts' }
                },

                {
                    path: '/definition/asset-classification',
                    name: 'Asset Classification',
                    component: () => import('@/views/definition/AssetClassification.vue'),
                    meta: { title: 'Asset Classification - Solution Experts' }
                },
                {
                    path: '/definition/asset-group',
                    name: 'Asset Group',
                    component: () => import('@/views/definition/AssetGroup.vue'),
                    meta: { title: 'Asset Group - Solution Experts' }
                },
                {
                    path: '/definition/asset-sub-group',
                    name: 'Asset Sub Group',
                    component: () => import('@/views/definition/AssetSubGroup.vue'),
                    meta: { title: 'Asset Sub Group - Solution Experts' }
                },
                {
                    path: '/definition/fixed-asset-profile',
                    name: 'Fixed Asset Profile',
                    component: () => import('@/views/definition/FixedAsset.vue'),
                    meta: { title: 'Fixed Asset Profile - Solution Experts' }
                },
                {
                    path: '/definition/account-group-mapping',
                    name: 'Account Group Mapping',
                    component: () => import('@/views/definition/AccountGroupMapping.vue'),
                    meta: { title: 'Account Group Mapping - Solution Experts' }
                },
                {
                    path: '/definition/general-account-mapping',
                    name: 'General Account & Voucher Mapping',
                    component: () => import('@/views/definition/GeneralAccountMapping.vue'),
                    meta: { title: 'General Account & Voucher Mapping - Solution Experts' }
                },
                {
                    path: '/definition/province',
                    name: 'Province',
                    component: () => import('@/views/definition/Province.vue'),
                    meta: { title: 'Province - Solution Experts' }
                },
                {
                    path: '/definition/city',
                    name: 'City',
                    component: () => import('@/views/definition/City.vue'),
                    meta: { title: 'City - Solution Experts' }
                },
                {
                    path: '/definition/salesman',
                    name: 'Salesman',
                    component: () => import('@/views/definition/Salesman.vue'),
                    meta: { title: 'Salesman - Solution Experts' }
                },
                {
                    path: '/definition/machine-no',
                    name: 'Machine No',
                    component: () => import('@/views/definition/MachineNo.vue'),
                    meta: { title: 'Machine No - Solution Experts' }
                },
                {
                    path: '/definition/cut-piece-reason',
                    name: 'Cut Piece Reason',
                    component: () => import('@/views/definition/CutPieceReason.vue'),
                    meta: { title: 'Cut Piece Reason - Solution Experts' }
                },
                {
                    path: '/definition/shift',
                    name: 'Shift',
                    component: () => import('@/views/definition/Shift.vue'),
                    meta: { title: 'Shift - Solution Experts' }
                },
                {
                    path: '/definition/shift-incharge',
                    name: 'Shift Incharge',
                    component: () => import('@/views/definition/ShiftIncharge.vue'),
                    meta: { title: 'Shift Incharge - Solution Experts' }
                },
                {
                    path: '/definition/machine-operator',
                    name: 'Machine Operator',
                    component: () => import('@/views/definition/MachineOperator.vue'),
                    meta: { title: 'Machine Operator - Solution Experts' }
                },
                {
                    path: '/definition/employee-grade',
                    name: 'Employee Grade',
                    component: () => import('@/views/definition/EmployeeGrade.vue'),
                    meta: { title: 'Employee Grade - Solution Experts' }
                },
                {
                    path: '/definition/employee-designation',
                    name: 'Employee Designation',
                    component: () => import('@/views/definition/EmployeeDesignation.vue'),
                    meta: { title: 'Employee Designation - Solution Experts' }
                },
                {
                    path: '/definition/employee-gender',
                    name: 'Employee Gender',
                    component: () => import('@/views/definition/EmployeeGender.vue'),
                    meta: { title: 'Employee Gender - Solution Experts' }
                },
                {
                    path: '/definition/employee-marital-status',
                    name: 'Employee Marital Status',
                    component: () => import('@/views/definition/EmployeeMaritalStatus.vue'),
                    meta: { title: 'Employee Marital Status - Solution Experts' }
                },
                {
                    path: '/definition/employee-religion',
                    name: 'Employee Religion',
                    component: () => import('@/views/definition/EmployeeReligion.vue'),
                    meta: { title: 'Employee Religion - Solution Experts' }
                },
                {
                    path: '/definition/employee-blood-group',
                    name: 'Employee Blood Group',
                    component: () => import('@/views/definition/EmployeeBloodGroup.vue'),
                    meta: { title: 'Employee Blood Group - Solution Experts' }
                },
                {
                    path: '/definition/employee-bank',
                    name: 'Employee Bank',
                    component: () => import('@/views/definition/EmployeeBank.vue'),
                    meta: { title: 'Employee Bank - Solution Experts' }
                },
                {
                    path: '/definition/employee-category',
                    name: 'Employee Category',
                    component: () => import('@/views/definition/EmployeeCategory.vue'),
                    meta: { title: 'Employee Category - Solution Experts' }
                },
                {
                    path: '/definition/employee',
                    name: 'Employee Profile',
                    component: () => import('@/views/definition/Employee.vue'),
                    meta: { title: 'Employee Profile - Solution Experts' }
                },
                {
                    path: '/definition/party-group',
                    name: 'Party Category',
                    component: () => import('@/views/definition/PartyGroup.vue'),
                    meta: { title: 'Party Category - Solution Experts' }
                },
                {
                    path: '/definition/party-adda-bilty',
                    name: 'Party Add Bilty',
                    component: () => import('@/views/definition/PartyAddaBilty.vue'),
                    meta: { title: 'Party Add Bilty - Solution Experts' }
                },
                {
                    path: '/definition/party-special-discount-group',
                    name: 'Party Special Discount Group',
                    component: () => import('@/views/definition/PartySpecialDiscountGroup.vue'),
                    meta: { title: 'Party Special Discount Group - Solution Experts' }
                },
                {
                    path: '/definition/party-special-discount-applicable',
                    name: 'Party Special Discount Applicable',
                    component: () => import('@/views/definition/PartySpecialDiscountApplicable.vue'),
                    meta: { title: 'Party Special Discount Applicable - Solution Experts' }
                },
                {
                    path: '/definition/party-grade',
                    name: 'Party Grade',
                    component: () => import('@/views/definition/PartyGrade.vue'),
                    meta: { title: 'Party Grade - Solution Experts' }
                },
                {
                    path: '/definition/party',
                    name: 'Party Profile',
                    component: () => import('@/views/definition/Party.vue'),
                    meta: { title: 'Party Profile - Solution Experts' }
                },
                {
                    path: '/definition/secondary-party',
                    name: 'Secondary Party Profile (Delivery)',
                    component: () => import('@/views/definition/SecondaryParty.vue'),
                    meta: { title: 'Secondary Party Profile (Delivery) - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-type',
                    name: 'Raw Product Sub Type',
                    component: () => import('@/views/definition/RawProductType.vue'),
                    meta: { title: 'Raw Product Sub Type - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-row-rack',
                    name: 'Raw Warehouse Row & Rack Layout',
                    component: () => import('@/views/definition/RawProductRowRack.vue'),
                    meta: { title: 'Raw Warehouse Row & Rack Layout - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-allocation',
                    name: 'Raw Product Allocation',
                    component: () => import('@/views/definition/RawProductAllocation.vue'),
                    meta: { title: 'Raw Product Allocation - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-category',
                    name: 'Raw Product Category',
                    component: () => import('@/views/definition/RawProductCategory.vue'),
                    meta: { title: 'Raw Product Category - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-group',
                    name: 'Raw Product Group',
                    component: () => import('@/views/definition/RawProductGroup.vue'),
                    meta: { title: 'Raw Product Group - Solution Experts' }
                },
                {
                    path: '/definition/raw-product-sub-group',
                    name: 'Raw Product Sub Group',
                    component: () => import('@/views/definition/RawProductSubGroup.vue'),
                    meta: { title: 'Raw Product Sub Group - Solution Experts' }
                },
                {
                    path: '/definition/raw-product',
                    name: 'Raw Product Profile',
                    component: () => import('@/views/definition/RawProduct.vue'),
                    meta: { title: 'Raw Product Profile - Solution Experts' }
                },
                {
                    path: '/definition/product-flexiable-general-cable',
                    name: 'Flexible & General Cable Profile',
                    component: () => import('@/views/definition/ProductFlexibleGeneralCable.vue'),
                    meta: { title: 'Flexible & General Cable Profile - Solution Experts' }
                },
                {
                    path: '/definition/product-optical-fiber-cable',
                    name: 'Optical Fiber Cable Profile',
                    component: () => import('@/views/definition/ProductFiberCable.vue'),
                    meta: { title: 'Optical Fiber Cable Profile - Solution Experts' }
                },
                {
                    path: '/definition/product-networking-cable',
                    name: 'Networking Cable Profile',
                    component: () => import('@/views/definition/ProductNetworkingCable.vue'),
                    meta: { title: 'Networking Cable Profile - Solution Experts' }
                },
                {
                    path: '/definition/profit-centers',
                    name: 'Profit Centers',
                    component: () => import('@/views/definition/ProfitCenters.vue'),
                    meta: { title: 'Profit Centers - Solution Experts' }
                },
                {
                    path: '/definition/cost-centers',
                    name: 'Cost Centers',
                    component: () => import('@/views/definition/CostCenters.vue'),
                    meta: { title: 'Cost Centers - Solution Experts' }
                },
                {
                    path: '/definition/sub-cost-centers-type',
                    name: 'Sub Cost Centers Type',
                    component: () => import('@/views/definition/SubCostCentersType.vue'),
                    meta: { title: 'Sub Cost Centers Type - Solution Experts' }
                },
                {
                    path: '/definition/sub-cost-centers',
                    name: 'Sub Cost Centers',
                    component: () => import('@/views/definition/SubCostCenters.vue'),
                    meta: { title: 'Sub Cost Centers - Solution Experts' }
                },
                {
                    path: '/definition/product-brand',
                    name: 'Brand',
                    component: () => import('@/views/definition/ProductBrand.vue'),
                    meta: { title: 'Brand - Solution Experts' }
                },
                {
                    path: '/definition/product-cable-shape',
                    name: 'Cable Shape',
                    component: () => import('@/views/definition/ProductShape.vue'),
                    meta: { title: 'Cable Shape - Solution Experts' }
                },
                {
                    path: '/definition/product-conductor-shape',
                    name: 'Conductor Shape',
                    component: () => import('@/views/definition/ProductConductorShape.vue'),
                    meta: { title: 'Conductor Shape - Solution Experts' }
                },
                {
                    path: '/definition/product-core-count',
                    name: 'Core Count',
                    component: () => import('@/views/definition/ProductCoreCount.vue'),
                    meta: { title: 'Core Count - Solution Experts' }
                },
                {
                    path: '/definition/product-conductor',
                    name: 'Conductor',
                    component: () => import('@/views/definition/ProductConductor.vue'),
                    meta: { title: 'Conductor - Solution Experts' }
                },
                {
                    path: '/definition/product-sheathing-material',
                    name: 'Sheathing Material',
                    component: () => import('@/views/definition/ProductSheatingMaterial.vue'),
                    meta: { title: 'Sheathing Material - Solution Experts' }
                },
                {
                    path: '/definition/product-construction',
                    name: 'Construction',
                    component: () => import('@/views/definition/ProductConstruction.vue'),
                    meta: { title: 'Construction - Solution Experts' }
                },
                {
                    path: '/definition/product-cable-outer-dia',
                    name: 'Cable Outer Dia',
                    component: () => import('@/views/definition/ProductCableOuterDia.vue'),
                    meta: { title: 'Cable Outer Dia - Solution Experts' }
                },
                {
                    path: '/definition/product-category',
                    name: 'Category',
                    component: () => import('@/views/definition/ProductCategory.vue'),
                    meta: { title: 'Category - Solution Experts' }
                },
                {
                    path: '/definition/product-shielding',
                    name: 'Shielding',
                    component: () => import('@/views/definition/ProductShielding.vue'),
                    meta: { title: 'Shielding - Solution Experts' }
                },
                {
                    path: '/definition/product-conductor-dia',
                    name: 'Conductor Dia',
                    component: () => import('@/views/definition/ProductConductorDia.vue'),
                    meta: { title: 'Conductor Dia - Solution Experts' }
                },
                {
                    path: '/definition/product-jacketing',
                    name: 'Jacketing',
                    component: () => import('@/views/definition/ProductJacketing.vue'),
                    meta: { title: 'Jacketing - Solution Experts' }
                },
                {
                    path: '/definition/product-usage',
                    name: 'Usage',
                    component: () => import('@/views/definition/ProductUsage.vue'),
                    meta: { title: 'Usage - Solution Experts' }
                },
                {
                    path: '/definition/product-color',
                    name: 'Color',
                    component: () => import('@/views/definition/ProductColor.vue'),
                    meta: { title: 'Color - Solution Experts' }
                },
                {
                    path: '/definition/product-packing-unit',
                    name: 'Packing Unit',
                    component: () => import('@/views/definition/ProductPackingUnit.vue'),
                    meta: { title: 'Packing Unit - Solution Experts' }
                },
                {
                    path: '/definition/product-packing-unit-length',
                    name: 'Packing Unit Length',
                    component: () => import('@/views/definition/ProductPackingUnitLength.vue'),
                    meta: { title: 'Packing Unit Length - Solution Experts' }
                },
                {
                    path: '/definition/product-length-marking',
                    name: 'Length Marking in Inches',
                    component: () => import('@/views/definition/ProductLengthMarking.vue'),
                    meta: { title: 'Length Marking in Inches - Solution Experts' }
                },
                {
                    path: '/definition/product-white-labeling',
                    name: 'White Labeling',
                    component: () => import('@/views/definition/ProductWhiteLabeling.vue'),
                    meta: { title: 'White Labeling - Solution Experts' }
                },
                {
                    path: '/definition/product-unit',
                    name: 'Unit of Measure',
                    component: () => import('@/views/definition/ProductUnit.vue'),
                    meta: { title: 'Unit of Measure - Solution Experts' }
                },
                {
                    path: '/definition/product-production-line',
                    name: 'Product Production Line',
                    component: () => import('@/views/definition/ProductProductionLine.vue'),
                    meta: { title: 'Product Production Line - Solution Experts' }
                },
                {
                    path: '/definition/product-group',
                    name: 'Product Group',
                    component: () => import('@/views/definition/ProductGroup.vue'),
                    meta: { title: 'Product Group - Solution Experts' }
                },
                {
                    path: '/definition/product-sub-group',
                    name: 'Product Sub Group',
                    component: () => import('@/views/definition/ProductSubGroup.vue'),
                    meta: { title: 'Product Sub Group - Solution Experts' }
                },
                {
                    path: '/definition/product-variant',
                    name: 'Finished Product Quality Control Variant',
                    component: () => import('@/views/definition/ProductVariant.vue'),
                    meta: { title: 'Finished Product Quality Control Variant - Solution Experts' }
                },
                {
                    path: '/definition/product-packaging-variant',
                    name: 'Finished Product Packaging Variant',
                    component: () => import('@/views/definition/ProductPackagingVariant.vue'),
                    meta: { title: 'Finished Product Packaging Variant - Solution Experts' }
                },
                {
                    path: '/definition/product-tier',
                    name: 'Finished Product Tier',
                    component: () => import('@/views/definition/ProductTier.vue'),
                    meta: { title: 'Finished Product Tier - Solution Experts' }
                },
                {
                    path: '/definition/product-steel-wire-size',
                    name: 'Steel Wire Size',
                    component: () => import('@/views/definition/ProductSize.vue'),
                    meta: { title: 'Steel Wire Size - Solution Experts' }
                },
                {
                    path: '/definition/product-article',
                    name: 'Finished Product Article',
                    component: () => import('@/views/definition/ProductArticle.vue'),
                    meta: { title: 'Finished Product Article - Solution Experts' }
                },
                {
                    path: '/definition/product-grade',
                    name: 'Finished Product Grade',
                    component: () => import('@/views/definition/ProductGrade.vue'),
                    meta: { title: 'Finished Product Grade - Solution Experts' }
                },
                {
                    path: '/definition/product',
                    name: 'Finished Product Profile',
                    component: () => import('@/views/definition/Product.vue'),
                    meta: { title: 'Finished Product Profile - Solution Experts' }
                },
                {
                    path: '/definition/permissions',
                    name: 'Permissions',
                    component: () => import('@/views/definition/Permissions.vue'),
                    meta: { title: 'Permissions - Solution Experts' }
                },
                {
                    path: '/definition/chart-of-acccount',
                    name: 'Chart Of Acccount',
                    component: () => import('@/views/definition/ChartOfAccount.vue'),
                    meta: { title: 'Chart Of Acccount - Solution Experts' }
                },
                {
                    path: '/definition/geographical-hierarchy',
                    name: 'Geographical Hierarchy',
                    component: () => import('@/views/definition/GeographicalHierarchy.vue'),
                    meta: { title: 'Geographical Hierarchy - Solution Experts' }
                },
                {
                    path: '/definition/sales-designation-hierarchy',
                    name: 'Sales Designation Hierarchy',
                    component: () => import('@/views/definition/SalesDesignationHierarchy.vue'),
                    meta: { title: 'Sales Designation Hierarchy - Solution Experts' }
                },
                {
                    path: '/definition/letter-of-credit',
                    name: 'Letter Of Credit Profile',
                    component: () => import('@/views/definition/LetterOfCredit.vue'),
                    meta: { title: 'Letter Of Credit Profile - Solution Experts' }
                },
                {
                    path: '/financial/opening-journal',
                    name: 'Opening Journal Voucher',
                    component: () => import('@/views/financial/OpeningJournal.vue'),
                    meta: { title: 'Opening Journal Voucher - Solution Experts' }
                },
                {
                    path: '/financial/journal',
                    name: 'Journal Voucher',
                    component: () => import('@/views/financial/Journal.vue'),
                    meta: { title: 'Journal Voucher - Solution Experts' }
                },
                {
                    path: '/financial/cash-voucher',
                    name: 'Cash Voucher',
                    component: () => import('@/views/financial/CashVoucher.vue'),
                    meta: { title: 'Cash Voucher - Solution Experts' }
                },
                {
                    path: '/financial/cash-receipt',
                    name: 'Cash Receipt',
                    component: () => import('@/views/financial/CashReceipt.vue'),
                    meta: { title: 'Cash Receipt - Solution Experts' }
                },
                {
                    path: '/financial/third-party-payment',
                    name: 'Third Party Payment',
                    component: () => import('@/views/financial/ThirdPartyPayment.vue'),
                    meta: { title: 'Third Party Payment - Solution Experts' }
                },
                {
                    path: '/financial/cash-payment',
                    name: 'Cash Payment',
                    component: () => import('@/views/financial/CashPayment.vue'),
                    meta: { title: 'Cash Payment - Solution Experts' }
                },
                {
                    path: '/financial/bank-receipt',
                    name: 'Bank Receipt',
                    component: () => import('@/views/financial/BankReceipt.vue'),
                    meta: { title: 'Bank Receipt - Solution Experts' }
                },
                {
                    path: '/financial/bank-payment',
                    name: 'Bank Payment',
                    component: () => import('@/views/financial/BankPayment.vue'),
                    meta: { title: 'Bank Payment - Solution Experts' }
                },
                {
                    path: '/financial/journal-factory',
                    name: 'Journal Voucher Factory',
                    component: () => import('@/views/financial/JournalFactory.vue'),
                    meta: { title: 'Journal Voucher Factory - Solution Experts' }
                },
                {
                    path: '/financial/cash-receipt-factory',
                    name: 'Cash Receipt Factory',
                    component: () => import('@/views/financial/CashReceiptFactory.vue'),
                    meta: { title: 'Cash Receipt Factory - Solution Experts' }
                },
                {
                    path: '/financial/cash-payment-factory',
                    name: 'Cash Payment Factory',
                    component: () => import('@/views/financial/CashPaymentFactory.vue'),
                    meta: { title: 'Cash Payment Factory - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-requisition',
                    name: 'Purchase Requisition',
                    component: () => import('@/views/purchase/PurchaseRequisition.vue'),
                    meta: { title: 'Purchase Requisition - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-order',
                    name: 'Purchase Order',
                    component: () => import('@/views/purchase/PurchaseOrder.vue'),
                    meta: { title: 'Purchase Order - Solution Experts' }
                },
                {
                    path: '/inventory/inward-gate-pass',
                    name: 'Inward Gate Pass',
                    component: () => import('@/views/inventory/InwardGatePass.vue'),
                    meta: { title: 'Inward Gate Pass - Solution Experts' }
                },
                {
                    path: '/inventory/goods-receipt-note',
                    name: 'Goods Receipt Note',
                    component: () => import('@/views/inventory/GoodsReceiptNote.vue'),
                    meta: { title: 'Goods Receipt Note - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-invoice',
                    name: 'Purchase Invoice',
                    component: () => import('@/views/purchase/PurchaseInvoice.vue'),
                    meta: { title: 'Purchase Invoice - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-invoice-regular',
                    name: 'Purchase Invoice (Regular)',
                    component: () => import('@/views/purchase/PurchaseInvoiceRegular.vue'),
                    meta: { title: 'Purchase Invoice - Solution Experts' }
                },
                {
                    path: '/inventory/goods-receipt-return-note',
                    name: 'Goods Receipt Return Note',
                    component: () => import('@/views/inventory/GoodsReceiptReturnNote.vue'),
                    meta: { title: 'Goods Receipt Return Note - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-return-regular',
                    name: 'Purchase Return (Debit Note) ',
                    component: () => import('@/views/purchase/PurchaseReturnRegular.vue'),
                    meta: { title: 'Purchase Return (Debit Note) - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-return-invoice',
                    name: 'Purchase Return (Debit Note)',
                    component: () => import('@/views/purchase/PurchaseReturnInvoice.vue'),
                    meta: { title: 'Purchase Return (Debit Note) - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-bill-of-materials',
                    name: 'Product Bill Of Materials',
                    component: () => import('@/views/inventory/BillOfMaterials.vue'),
                    meta: { title: 'Product Bill Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-production',
                    name: 'Product Production',
                    component: () => import('@/views/inventory/Production.vue'),
                    meta: { title: 'Product Production - Solution Experts' }
                },
                {
                    path: '/inventory/production-order',
                    name: 'Production Order',
                    component: () => import('@/views/inventory/ProductionOrder.vue'),
                    meta: { title: 'Production Order - Solution Experts' }
                },
                {
                    path: '/inventory/material-required-voucher',
                    name: 'Production Material Request Voucher',
                    component: () => import('@/views/inventory/MaterialRequired.vue'),
                    meta: { title: 'Production Material Request Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/material-issue-voucher',
                    name: 'Production Material Issue Voucher',
                    component: () => import('@/views/inventory/MaterialIssue.vue'),
                    meta: { title: 'Production Material Issue Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-production',
                    name: 'Semi & Finished Product Production',
                    component: () => import('@/views/inventory/FinishedProductProduction.vue'),
                    meta: { title: 'Semi & Finished Product Production - Solution Experts' }
                },
                {
                    path: '/inventory/composition-of-materials',
                    name: 'Semi & Finished Composition Of Materials',
                    component: () => import('@/views/inventory/CompositionOfMaterials.vue'),
                    meta: { title: 'Semi & Finished Composition Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-bill-of-materials',
                    name: 'Semi & Finished Bill Of Materials',
                    component: () => import('@/views/inventory/FinishedProductBillOfMaterials.vue'),
                    meta: { title: 'Semi & Finished Bill Of Materials - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-adjustment',
                    name: 'Product Adjustment Voucher',
                    component: () => import('@/views/inventory/RawProductAdjustment.vue'),
                    meta: { title: 'Product Adjustment Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/product-adjustment-value-based',
                    name: 'Finished Product Adjustment Value Based Voucher',
                    component: () => import('@/views/inventory/FinishedProductAdjustmentValueBased.vue'),
                    meta: { title: 'Finished Product Adjustment Value Based Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-adjustment-value-based',
                    name: 'Product Adjustment Value Based Voucher',
                    component: () => import('@/views/inventory/RawProductAdjustmentValueBased.vue'),
                    meta: { title: 'Product Adjustment Value Based Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-consumption',
                    name: 'Raw Product Consumption Voucher',
                    component: () => import('@/views/inventory/RawProductConsumption.vue'),
                    meta: { title: 'Raw Product Consumption Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-consumption-return',
                    name: 'Raw Product Consumption Return Voucher',
                    component: () => import('@/views/inventory/RawProductConsumptionReturn.vue'),
                    meta: { title: 'Raw Product Consumption Return Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/raw-product-transfer',
                    name: 'Product Transfer Voucher',
                    component: () => import('@/views/inventory/RawProductTransfer.vue'),
                    meta: { title: 'Product Transfer Voucher - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-transfer',
                    name: 'Finished Product Transfer Voucher',
                    component: () => import('@/views/inventory/FinishedProductTransfer.vue'),
                    meta: { title: 'Finished Product Transfer Voucher - Solution Experts' }
                },
                {
                    path: '/sales/sales-order',
                    name: 'Sales Order',
                    component: () => import('@/views/sales/SalesOrder.vue'),
                    meta: { title: 'Sales Order - Solution Experts' }
                },
                {
                    path: '/inventory/delivery-challan',
                    name: 'Delivery Challan',
                    component: () => import('@/views/inventory/DeliveryChallan.vue'),
                    meta: { title: 'Delivery Challan - Solution Experts' }
                },
                {
                    path: '/sales/sales-invoice',
                    name: 'Sales Invoice',
                    component: () => import('@/views/sales/SalesInvoice.vue'),
                    meta: { title: 'Sales Invoice - Solution Experts' }
                },
                {
                    path: '/sales/sales-return',
                    name: 'Sales Return (Credit Note)',
                    component: () => import('@/views/sales/SalesReturn.vue'),
                    meta: { title: 'Sales Return (Credit Note) - Solution Experts' }
                },
                {
                    path: '/sales/sales-discount-policy',
                    name: 'Sales Discount Policy',
                    component: () => import('@/views/sales/SalesDiscountPolicy.vue'),
                    meta: { title: 'Sales Discount Policy - Solution Experts' }
                },
                {
                    path: '/sales/sales-price-list',
                    name: 'Sales Price List',
                    component: () => import('@/views/sales/SalesPriceList.vue'),
                    meta: { title: 'Sales Price List - Solution Experts' }
                },
                {
                    path: '/sales/sales-invoice-regular',
                    name: 'Sales Invoice ',
                    component: () => import('@/views/sales/SalesInvoiceRegular.vue'),
                    meta: { title: 'Sales Invoice - Solution Experts ' }
                },
                {
                    path: '/sales/sales-return-regular',
                    name: 'Sales Return (Credit Note)',
                    component: () => import('@/views/sales/SalesReturnRegular.vue'),
                    meta: { title: 'Sales Return (Credit Note)' }
                },
                {
                    path: '/inventory/delivery-challan-return',
                    name: 'Delivery Challan Return',
                    component: () => import('@/views/inventory/DeliveryChallanReturn.vue'),
                    meta: { title: 'Delivery Challan Return' }
                },
                {
                    path: '/financial/account-ledger',
                    name: 'Account Ledger',
                    component: () => import('@/views/reports/financial/AccountLedger.vue'),
                    meta: { title: 'Account Ledger - Solution Experts' }
                },
                {
                    path: '/financial/financial-voucher-activity',
                    name: 'Financial Voucher Activity',
                    component: () => import('@/views/reports/financial/FinancialVoucherActivity.vue'),
                    meta: { title: 'Financial Voucher Activity - Solution Experts' }
                },
                {
                    path: '/financial/trial-balance',
                    name: 'Trial Balance',
                    component: () => import('@/views/reports/financial/TrialBalance.vue'),
                    meta: { title: 'Trial Balance - Solution Experts' }
                },
                {
                    path: '/financial/trial-balance-transcation-level',
                    name: 'Trial Balance ',
                    component: () => import('@/views/reports/financial/TrialBalanceTranscationLevel.vue'),
                    meta: { title: 'Trial Balance - Solution Experts' }
                },
                {
                    path: '/financial/cash-bank-balance-summary',
                    name: 'Cash & Bank Balance Summary',
                    component: () => import('@/views/reports/financial/CashBankBalanceSummary.vue'),
                    meta: { title: 'Cash & Bank Balance Summary - Solution Experts' }
                },
                {
                    path: '/financial/expense-balance-comparison-summary',
                    name: 'Expense Balance Comparison Summary',
                    component: () => import('@/views/reports/financial/ExpenseBalanceComparisonSummary.vue'),
                    meta: { title: 'Expense Balance Comparison Summary - Solution Experts' }
                },
                {
                    path: '/financial/cash-book',
                    name: 'Cash Book',
                    component: () => import('@/views/reports/financial/CashBook.vue'),
                    meta: { title: 'Cash Book - Solution Experts' }
                },
                {
                    path: '/financial/cash-flow',
                    name: 'Cash Flow',
                    component: () => import('@/views/reports/financial/CashFlow.vue'),
                    meta: { title: 'Cash Flow - Solution Experts' }
                },
                {
                    path: '/financial/cash-flow-transcation-level',
                    name: 'Cash Flow ',
                    component: () => import('@/views/reports/financial/CashFlowTranscationLevel.vue'),
                    meta: { title: 'Cash Flow - Solution Experts' }
                },
                {
                    path: '/financial/letter-of-credit-balance-summary',
                    name: 'Letter Of Credit Balance Summary',
                    component: () => import('@/views/reports/financial/LetterOfCreditBalanceSummary.vue'),
                    meta: { title: 'Letter Of Credit Balance Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-ledger',
                    name: 'Customer Ledger',
                    component: () => import('@/views/reports/customer/CustomerLedger.vue'),
                    meta: { title: 'Customer Ledger - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance-summary',
                    name: 'Customer Balance Summary',
                    component: () => import('@/views/reports/customer/CustomerBalanceSummary.vue'),
                    meta: { title: 'Customer Balance Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance',
                    name: 'Customer Balance',
                    component: () => import('@/views/reports/customer/CustomerBalance.vue'),
                    meta: { title: 'Customer Balance - Solution Experts' }
                },
                {
                    path: '/customer/customer-balance-movement-summary',
                    name: 'Customer Balance Movement Summary',
                    component: () => import('@/views/reports/customer/CustomerBalanceMovementSummary.vue'),
                    meta: { title: 'Customer Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/customer/customer-aging',
                    name: 'Customer Aging',
                    component: () => import('@/views/reports/customer/CustomerAging.vue'),
                    meta: { title: 'Customer Aging - Solution Experts' }
                },
                {
                    path: '/customer/customer-aging-summary',
                    name: 'Customer Aging Summary',
                    component: () => import('@/views/reports/customer/CustomerAgingSummary.vue'),
                    meta: { title: 'Customer Aging Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-ledger',
                    name: 'Supplier Ledger',
                    component: () => import('@/views/reports/supplier/SupplierLedger.vue'),
                    meta: { title: 'Supplier Ledger - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance-summary',
                    name: 'Supplier Balance Summary',
                    component: () => import('@/views/reports/supplier/SupplierBalanceSummary.vue'),
                    meta: { title: 'Supplier Balance Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance',
                    name: 'Supplier Balance',
                    component: () => import('@/views/reports/supplier/SupplierBalance.vue'),
                    meta: { title: 'Supplier Balance - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-balance-movement-summary',
                    name: 'Supplier Balance Movement Summary',
                    component: () => import('@/views/reports/supplier/SupplierBalanceMovementSummary.vue'),
                    meta: { title: 'Supplier Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-aging',
                    name: 'Supplier Aging',
                    component: () => import('@/views/reports/supplier/SupplierAging.vue'),
                    meta: { title: 'Supplier Aging - Solution Experts' }
                },
                {
                    path: '/supplier/supplier-aging-summary',
                    name: 'Supplier Aging Summary',
                    component: () => import('@/views/reports/supplier/SupplierAgingSummary.vue'),
                    meta: { title: 'Supplier Aging Summary - Solution Experts' }
                },
                {
                    path: '/humanResource/employee-ledger',
                    name: 'Employee Ledger',
                    component: () => import('@/views/reports/humanResource/EmployeeLedger.vue'),
                    meta: { title: 'Employee Ledger - Solution Experts' }
                },
                {
                    path: '/humanResource/employee-balance-summary',
                    name: 'Employee Balance Summary',
                    component: () => import('@/views/reports/humanResource/EmployeeBalanceSummary.vue'),
                    meta: { title: 'Employee Balance Summary - Solution Experts' }
                },
                {
                    path: '/inventory/inventory-voucher-activity',
                    name: 'Inventory Voucher Activity',
                    component: () => import('@/views/reports/inventory/InventoryVoucherActivity.vue'),
                    meta: { title: 'Inventory Voucher Activity - Solution Experts' }
                },
                {
                    path: '/inventory/production-analysis-report',
                    name: 'Production Analysis',
                    component: () => import('@/views/reports/inventory/ProductionAnalysis.vue'),
                    meta: { title: 'Production Analysis - Solution Experts' }
                },
                {
                    path: '/inventory/production-order-analysis-report',
                    name: 'Production Order Analysis',
                    component: () => import('@/views/reports/inventory/ProductionOrderAnalysis.vue'),
                    meta: { title: 'Production Order Analysis - Solution Experts' }
                },
                {
                    path: '/inventory/product-ledger',
                    name: 'Product Ledger',
                    component: () => import('@/views/reports/inventory/ProductLedger.vue'),
                    meta: { title: 'Product Ledger - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-by-amount',
                    name: 'Product Balance With Amount',
                    component: () => import('@/views/reports/inventory/ProductBalanceByAmount.vue'),
                    meta: { title: 'Product Balance With Amount - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance',
                    name: 'Product Balance',
                    component: () => import('@/views/reports/inventory/ProductBalance.vue'),
                    meta: { title: 'Product Balance - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-movement-summary',
                    name: 'Product Balance Movement Summary',
                    component: () => import('@/views/reports/inventory/ProductBalanceMovementSummary.vue'),
                    meta: { title: 'Product Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/inventory/product-ledger-by-warehouse',
                    name: 'Product Ledger By Warehouse',
                    component: () => import('@/views/reports/inventory/ProductLedgerByWarehouse.vue'),
                    meta: { title: 'Product Ledger By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-by-warehouse',
                    name: 'Product Balance By Warehouse',
                    component: () => import('@/views/reports/inventory/ProductBalanceByWarehouse.vue'),
                    meta: { title: 'Product Balance By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-ledger',
                    name: 'Finished Product Ledger',
                    component: () => import('@/views/reports/inventory/FinishedProductLedger.vue'),
                    meta: { title: 'Finished Product Ledger - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance',
                    name: 'Finished Product Balance',
                    component: () => import('@/views/reports/inventory/FinishedProductBalance.vue'),
                    meta: { title: 'Finished Product Balance - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance-movement-summary',
                    name: 'Finished Product Balance Movement Summary',
                    component: () => import('@/views/reports/inventory/FinishedProductBalanceMovementSummary.vue'),
                    meta: { title: 'Finished Product Balance Movement Summary - Solution Experts' }
                },
                {
                    path: '/inventory/product-balance-monthly-comparison',
                    name: 'Product Balance Monthly Comparison',
                    component: () => import('@/views/reports/inventory/ProductBalanceMonthlyComparison.vue'),
                    meta: { title: 'Product Balance Monthly Comparison - Solution Experts' }
                },
                {
                    path: '/inventory/product-with-no-issuance-delivery',
                    name: 'Product With No Issuance & Delivery',
                    component: () => import('@/views/reports/inventory/ProductWithNoIssuanceDelivery.vue'),
                    meta: { title: 'Product With No Issuance & Delivery - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-ledger-by-warehouse',
                    name: 'Finished Product Ledger By Warehouse',
                    component: () => import('@/views/reports/inventory/FinishedProductLedgerByWarehouse.vue'),
                    meta: { title: 'Finished Product Ledger By Warehouse - Solution Experts' }
                },
                {
                    path: '/inventory/finished-product-balance-by-warehouse',
                    name: 'Finished Product Balance By Warehouse',
                    component: () => import('@/views/reports/inventory/FinishedProductBalanceByWarehouse.vue'),
                    meta: { title: 'Finished Product Balance By Warehouse - Solution Experts' }
                },
                {
                    path: '/sales/sales-order-report',
                    name: 'Sales Order Report',
                    component: () => import('@/views/reports/sales/SalesOrder.vue'),
                    meta: { title: 'Sales Order Report - Solution Experts' }
                },
                {
                    path: '/sales/sales-order-analysis-report',
                    name: 'Sales Order Analysis Report',
                    component: () => import('@/views/reports/sales/SalesOrderAnalysis.vue'),
                    meta: { title: 'Sales Order Analysis Report - Solution Experts' }
                },
                {
                    path: '/sales/sales-analysis-report',
                    name: 'Sales Analysis Report',
                    component: () => import('@/views/reports/sales/SalesAnalysis.vue'),
                    meta: { title: 'Sales Analysis Report - Solution Experts' }
                },
                {
                    path: '/sales/sales-report',
                    name: 'Sales Report',
                    component: () => import('@/views/reports/sales/Sales.vue'),
                    meta: { title: 'Sales Report - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-order-report',
                    name: 'Purchase Order Report',
                    component: () => import('@/views/reports/purchase/PurchaseOrder.vue'),
                    meta: { title: 'Purchase Order Report - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-order-analysis-report',
                    name: 'Purchase Order Analysis Report',
                    component: () => import('@/views/reports/purchase/PurchaseOrderAnalysis.vue'),
                    meta: { title: 'Purchase Order Analysis Report - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-report',
                    name: 'Purchase Report',
                    component: () => import('@/views/reports/purchase/Purchase.vue'),
                    meta: { title: 'Purchase Report - Solution Experts' }
                },
                {
                    path: '/purchase/purchase-analysis-report',
                    name: 'Purchase Analysis Report',
                    component: () => import('@/views/reports/purchase/PurchaseAnalysis.vue'),
                    meta: { title: 'Purchase Analysis Report - Solution Experts' }
                },
                {
                    path: '/dashboard/financial',
                    name: 'Financial Dashboard',
                    component: () => import('@/views/dashboard/FinancialDashboard.vue'),
                    meta: { title: 'Financial Dashboard - Solution Experts' }
                },
                {
                    path: '/dashboard/customer',
                    name: 'Customer Dashboard',
                    component: () => import('@/views/dashboard/CustomerDashboard.vue'),
                    meta: { title: 'Customer Dashboard - Solution Experts' }
                },
                {
                    path: '/dashboard/supplier',
                    name: 'Supplier Dashboard',
                    component: () => import('@/views/dashboard/SupplierDashboard.vue'),
                    meta: { title: 'Supplier Dashboard - Solution Experts' }
                },
                {
                    path: '/dashboard/inventory',
                    name: 'Inventory Dashboard',
                    component: () => import('@/views/dashboard/InventoryDashboard.vue'),
                    meta: { title: 'Inventory Dashboard - Solution Experts' }
                },
                {
                    path: '/dashboard/deliveryChallan',
                    name: 'Delivery Challan Dashboard',
                    component: () => import('@/views/dashboard/DeliveryChallanDashboard.vue'),
                    meta: { title: 'Delivery Challan Dashboard - Solution Experts' }
                },
                {
                    path: '/uikit/formlayout',
                    name: 'formlayout',
                    component: () => import('@/views/uikit/FormLayout.vue')
                },
                {
                    path: '/uikit/input',
                    name: 'input',
                    component: () => import('@/views/uikit/InputDoc.vue')
                },
                {
                    path: '/uikit/button',
                    name: 'button',
                    component: () => import('@/views/uikit/ButtonDoc.vue')
                },
                {
                    path: '/uikit/table',
                    name: 'table',
                    component: () => import('@/views/uikit/TableDoc.vue')
                },
                {
                    path: '/uikit/list',
                    name: 'list',
                    component: () => import('@/views/uikit/ListDoc.vue')
                },
                {
                    path: '/uikit/tree',
                    name: 'tree',
                    component: () => import('@/views/uikit/TreeDoc.vue')
                },
                {
                    path: '/uikit/panel',
                    name: 'panel',
                    component: () => import('@/views/uikit/PanelsDoc.vue')
                },

                {
                    path: '/uikit/overlay',
                    name: 'overlay',
                    component: () => import('@/views/uikit/OverlayDoc.vue')
                },
                {
                    path: '/uikit/media',
                    name: 'media',
                    component: () => import('@/views/uikit/MediaDoc.vue')
                },
                {
                    path: '/uikit/message',
                    name: 'message',
                    component: () => import('@/views/uikit/MessagesDoc.vue')
                },
                {
                    path: '/uikit/file',
                    name: 'file',
                    component: () => import('@/views/uikit/FileDoc.vue')
                },
                {
                    path: '/uikit/menu',
                    name: 'menu',
                    component: () => import('@/views/uikit/MenuDoc.vue')
                },
                {
                    path: '/uikit/charts',
                    name: 'charts',
                    component: () => import('@/views/uikit/ChartDoc.vue')
                },
                {
                    path: '/uikit/misc',
                    name: 'misc',
                    component: () => import('@/views/uikit/MiscDoc.vue')
                },
                {
                    path: '/uikit/timeline',
                    name: 'timeline',
                    component: () => import('@/views/uikit/TimelineDoc.vue')
                },
                {
                    path: '/pages/empty',
                    name: 'empty',
                    component: () => import('@/views/pages/Empty.vue')
                },
                {
                    path: '/pages/crud',
                    name: 'crud',
                    component: () => import('@/views/pages/Crud.vue')
                },
                {
                    path: '/documentation',
                    name: 'documentation',
                    component: () => import('@/views/pages/Documentation.vue')
                }
            ]
        },
        {
            path: '/landing',
            name: 'landing',
            component: () => import('@/views/pages/Landing.vue')
        },
        {
            path: '/pages/notfound',
            name: 'notfound',
            component: () => import('@/views/pages/NotFound.vue')
        },

        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/auth/Login.vue')
        },
        {
            path: '/access',
            name: 'accessDenied',
            component: () => import('@/views/pages/auth/Access.vue')
        },
        {
            path: '/error',
            name: 'error',
            component: () => import('@/views/pages/auth/Error.vue')
        },
        { path: '/:pathMatch(.*)*', redirect: '/access' }
    ]
});

const publicPages = ['/login', '/access', '/error', '/'];

router.beforeEach((to, from, next) => {
    const authRequired = !publicPages.includes(to.path);
    const isLoggedIn = AuthService.isAuthenticated();

    if (!isLoggedIn && authRequired) {
        return next('/login');
    }

    if (to.path === '/login' && isLoggedIn) {
        return next('/');
    }

    if (!isLoggedIn && to.path === '/') {
        return next('/login');
    }

    if (authRequired) {
        const activeBranchId = JSON.parse(localStorage.getItem('activeBranchId'));
        const rawMenu = JSON.parse(localStorage.getItem('menu') || '{}');

        // Get menu items for the active branch
        const menuItems = rawMenu[activeBranchId] || [];

        const flattenLinks = (items) => {
            let links = [];
            items.forEach((item) => {
                if (item.link) {
                    links.push(item.link.startsWith('/') ? item.link : '/' + item.link);
                }
                if (item.children && item.children.length > 0) {
                    links = links.concat(flattenLinks(item.children));
                }
            });
            return links;
        };

        const allowedPaths = flattenLinks(menuItems);

        if (!allowedPaths.includes(to.path)) {
            return next('/access');
        }
    }

    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = 'Solution Experts';
    }

    next();
});

export default router;
